








































import Vue from "vue";
// import { mapMutations } from "vuex";
// import { ProductMutations } from "../../store/modules/product/definitions.product";
// import axios from "axios";
import { GET_IMAGE_URL } from "@/plugins/constants";

export default Vue.extend({
  name: "productCard",
  props: {
    SkuCode: {
      type: String,
      required: true,
    },
    Title: String,
    Url: String,
    Price: {
      type: String,
      default: "",
    },
    Discount: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      // loader_image: false,
      images: { out: "", over: ""},
      hover: false,
      currentImage: "",
      titleFinal: "",
      details: "",
    };
  },
  async created() {
    const word = this.Title.split(" ");

    this.titleFinal = [word[0], word[1]].join(" ");

    const aux = [];
    for (let index = 2; index < word.length; index++) {
      aux.push(word[index]);
    }
    this.details = aux.join(" ");

    this.images.out = `${GET_IMAGE_URL(true)}/articles/${this.$props.SkuCode}/card/0.webp`;
   
    this.currentImage = this.images.out;
  },
  /*mounted(){
    //this.images.over = `${GET_IMAGE_URL(true)}/articles/${this.$props.SkuCode}/card/1.webp`;

    document.getElementById("product_card")!.addEventListener('load', ()=> console.log("gola"))

    //console.log()

    if ((this.$refs.product_card as any).image != null) {
      this.images.over = `${GET_IMAGE_URL(true)}/articles/${this.$props.SkuCode}/card/1.webp`;
    } else {
      (this.$refs.product_card as any).$el.addEventListener('load', () => {
        this.images.over = `${GET_IMAGE_URL(true)}/articles/${this.$props.SkuCode}/card/1.webp`;
      })
    }
  },*/
  methods: {
    loadOverimage(){
      this.images.over = `${GET_IMAGE_URL(true)}/articles/${this.$props.SkuCode}/card/1.webp`;
    },
    changeImageWhen(state: string) {
      this.currentImage = this.images[state];
    },
    descriptionProduct() {
      this.$router.push({
        name: "DescriptionProduct",
        params: { productUrl: this.$props.Url },
      });
    },
  },
});
